const version = "13.0.0";

export default version;


// WEBPACK FOOTER //
// ./src/components-kr/content/version.js